import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import _get from 'lodash/get'
import {FacetimeStatusType, WorkLevelEnum, WorkLevelType} from './constant'

// [文字小助手] http://wiki.xunlei.cn/pages/viewpage.action?pageId=127569233
export const chatting_helper_homepage = createAsyncThunk(
  'ChatWork/live/facetime/chatting_helper_homepage',
  async (arg: any, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Omit<ChatDataInterface, 'avatar_url'> & {
          member: Member
        }
      >
    >('/live/facetime/chatting_helper_homepage', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)
// [视频小助手] http://wiki.xunlei.cn/pages/viewpage.action?pageId=127569543
export const facetime_helper_homepage = createAsyncThunk(
  'ChatWork/live/facetime/facetime_helper_homepage',
  async (arg: any, store: any) => {
    const resp = await http.post<HiyaRes<FacetimeDataInterface>>(
      '/live/facetime/facetime_helper_homepage',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

export interface SayHiWorkDataItem {
  value: number // 当前数据
  rate: number[] // 当前进度多少。0-100
  upgrade: boolean // 是否达到升级要求
  upgrade_value: number // 还差多少可以升级
}
export interface SayHiWorkData {
  had_data: boolean // 是否有数据
  level: WorkLevelType // 本周⽂字等级
  affinity_count: number // 亲密度LV10以上⼈数
  chat_convert_income: SayHiWorkDataItem | null // 私信转化收益
  quick_reply_rate: SayHiWorkDataItem | null // 秒回率
  round_5_rate: SayHiWorkDataItem | null // 5回合达成率
  round_20_rate: SayHiWorkDataItem | null // 20回合达成率
  total_income: SayHiWorkDataItem | null // 总收益
}
interface SayHiInfo {
  // level: WorkLevelType // 本周⽂字等级
  level: WorkLevelEnum // 本周⽂字等级
  cur_count: number // 实际已经下发的新招呼数
  max_count: number // 本周⽂字等级对应的预计下发流量上限
  rate: number // 额外奖励多少⽐例. eg:30
  total_income: number // 达⼈的私信总收益
  base_income: number // 达⼈的私信基础收益
  ext_income: number // 达⼈的私信额外奖励收益
}
export interface RelationRank {
  member: Member // 达人信息
  level: number // 亲密等级
  usd: number // 贡献收益
  jump: string // 跳转当前用户聊天界面
}
interface ChatDataInterface {
  err_msg?: string
  say_hi_info?: SayHiInfo
  this_week_data?: SayHiWorkData
  last_week_data?: SayHiWorkData
  suggest?: string // 建议
  tips?: string // 历史记录的补充信息
  avatar_url?: string
  lv10_icon?: string
  bottom_msg?: string // 顶部等级的补充信息
  rank_list?: RelationRank[] // 排名等级
}

interface FacetimeWorkDataItem {
  value: number // 当前数据
  status: FacetimeStatusType // 0 好， 1一般，2差
}
interface FacetimeWorkData {
  had_data: boolean // 是否有数据
  level: WorkLevelType
  match_convert_income: FacetimeWorkDataItem | null // 匹配转化收益
  match_convert_uv: FacetimeWorkDataItem | null // 匹配转化⼈数
  match_60s: FacetimeWorkDataItem | null // 匹配60s达成率
}

interface FacetimeInfo {
  level: WorkLevelType // 本周⽂字等级
  cur_count: number // 本周已经下发的匹配pv
  max_count: number // 本周视频等级对应的基础视频流量数
}

interface FacetimeDataInterface {
  err_msg?: string
  lock_msg?: string // 如果⻓度⼤于0，显示这次的⽂案
  bottom_msg?: string // 顶部等级的补充信息
  facetime_info?: FacetimeInfo
  this_week_data?: FacetimeWorkData
  last_week_data?: FacetimeWorkData
  suggest?: string
}

interface Member {
  avatar_urls: {aspect_low: {urls: string[]}}
  name: string
  id: number
}

export interface InitialStateType {
  chatData?: ChatDataInterface
  facetimeData?: FacetimeDataInterface
}

const initialState: InitialStateType = {
  chatData: {},
  facetimeData: {},
}

export const ChatWorkSlice = createSlice({
  name: 'ChatWork',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(chatting_helper_homepage.fulfilled, (state, action) => {
      const {member, ...rest} = action.payload
      Object.assign(state, {
        chatData: {
          ...rest,
          avatar_url: _get(member, 'avatar_urls.aspect_low.urls.[0]', ''),
        },
      })
    })
    builder.addCase(facetime_helper_homepage.fulfilled, (state, action) => {
      Object.assign(state, {
        facetimeData: {
          ...action.payload,
        },
      })
    })
  },
})
export default ChatWorkSlice.reducer
export const ChatWorkActions = ChatWorkSlice.actions

export const useChatDataState = () => {
  const data = useSelector((state) => {
    return state.ChatWork.chatData
  })
  return data
}
export const useFacetimeDataState = () => {
  const data = useSelector((state) => {
    return state.ChatWork.facetimeData
  })
  return data
}
